import React from 'react';
import successIcon from '@assets/svg/successStatusIcon.svg';
import timeoutIcon from '@assets/svg/timedoutIcon.svg';
import { useTranslate } from '@translations/useTranslate';
import successStatusStyles from './VisitRequestStatus.module.scss';

export const VisitRequestStatus: React.FC<{
  isSuccess?: boolean;
  requestNumber: string;
  isRejected?: boolean;
}> = ({ isSuccess, requestNumber, isRejected }) => {
  const { t } = useTranslate();
  return (
    <>
      <div className={successStatusStyles.status_wrapper}>
        {isRejected ? (
          <>
            <span className={successStatusStyles.status_wrapper__icon}>
              <img src={successIcon} alt="success" />
            </span>
            <span className={successStatusStyles.status_wrapper__success_message}>
              <h4>{t('rejectMessage.title')}</h4>
            </span>
          </>
        ) : isSuccess ? (
          <>
            <span className={successStatusStyles.status_wrapper__icon}>
              <img src={successIcon} alt="success" />
            </span>
            <span className={successStatusStyles.status_wrapper__success_message}>
              <h4>{t('successMessage.title')}</h4>
            </span>
            <span
              className={
                'w-100 d-flex justify-content-center align-items-center flex-row pb-5 mb-8'
              }
            >
              <span>
                {' '}
                {t('successMessage.ticket')}{' '}
                <span className={successStatusStyles.status_wrapper__request_number}>
                  {requestNumber}
                </span>
              </span>
            </span>
          </>
        ) : (
          <>
            <span className={successStatusStyles.status_wrapper__icon}>
              <img src={timeoutIcon} alt="timeout" />
            </span>
            <span className={successStatusStyles.status_wrapper__timeout_message}>
              <h4>Invalid Data</h4>
            </span>
          </>
        )}
      </div>
    </>
  );
};
